/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IMedia,
  Udi,
} from '../models/index';
import {
    IMediaFromJSON,
    IMediaToJSON,
    UdiFromJSON,
    UdiToJSON,
} from '../models/index';

export interface CandidateImageBase64Request {
    candidateId?: string;
}

export interface CreateDocumentImageRequest {
    mediaId?: number;
    previewProfileNode?: Udi;
    colorNodeId?: Udi;
    lang?: string;
}

export interface GetCVPreviewDocumentRequest {
    mediaId?: number;
    previewProfileNode?: Udi;
    colorNodeId?: Udi;
}

export interface GetDocumentImageRequest {
    mediaId?: number;
    lang?: string;
}

export interface SaveMediasRequest {
    mediaId?: number;
}

export interface UserImageRequest {
    userId?: string;
    defaultImage?: string;
}

export interface UserImageBase64Request {
    userId?: string;
}

/**
 * 
 */
export class FileApi extends runtime.BaseAPI {

    /**
     */
    async candidateImageBase64Raw(requestParameters: CandidateImageBase64Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.candidateId !== undefined) {
            queryParameters['candidateId'] = requestParameters.candidateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/CandidateImageBase64`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async candidateImageBase64(requestParameters: CandidateImageBase64Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.candidateImageBase64Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createDocumentImageRaw(requestParameters: CreateDocumentImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMedia>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.previewProfileNode !== undefined) {
            queryParameters['previewProfileNode'] = requestParameters.previewProfileNode;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/CreateDocumentImage`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IMediaFromJSON(jsonValue));
    }

    /**
     */
    async createDocumentImage(requestParameters: CreateDocumentImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMedia> {
        const response = await this.createDocumentImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCVPreviewDocumentRaw(requestParameters: GetCVPreviewDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.previewProfileNode !== undefined) {
            queryParameters['previewProfileNode'] = requestParameters.previewProfileNode;
        }

        if (requestParameters.colorNodeId !== undefined) {
            queryParameters['colorNodeId'] = requestParameters.colorNodeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/GetCVPreviewDocument`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getCVPreviewDocument(requestParameters: GetCVPreviewDocumentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCVPreviewDocumentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDocumentImageRaw(requestParameters: GetDocumentImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMedia>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/GetDocumentImage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IMediaFromJSON(jsonValue));
    }

    /**
     */
    async getDocumentImage(requestParameters: GetDocumentImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMedia> {
        const response = await this.getDocumentImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveAllMediasRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/SaveAllMedias`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveAllMedias(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveAllMediasRaw(initOverrides);
    }

    /**
     */
    async saveMediasRaw(requestParameters: SaveMediasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.mediaId !== undefined) {
            queryParameters['mediaId'] = requestParameters.mediaId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/SaveMedias`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveMedias(requestParameters: SaveMediasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveMediasRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userImageRaw(requestParameters: UserImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.defaultImage !== undefined) {
            queryParameters['defaultImage'] = requestParameters.defaultImage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/UserImage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userImage(requestParameters: UserImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userImageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userImageBase64Raw(requestParameters: UserImageBase64Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/File/UserImageBase64`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async userImageBase64(requestParameters: UserImageBase64Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.userImageBase64Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
